<div class="breadcrumbs">
    <div>/</div>
    <div>Governance</div>
    <div>/</div>
    <div class="hasLink" [routerLink]="['/data-catalogue']">Data Catalogues</div>
    <div>/</div>
    <div>Facilis Origin AIXM 5.1</div>
    <div>/</div>
    <div>Group: {{ propertyGroupName }}</div>
</div>
<mat-toolbar>
  <span>
    <h3>Group: {{ propertyGroupName }}</h3>
  </span>
</mat-toolbar>

<div class="metadata-container" [ngClass]="{'expanded': metadataExpanded, 'collapsed': !metadataExpanded}">
    <div class="metadata-container-header">
        <h4>Metadata</h4>
        <div *ngIf="!metadataExpanded" class="expand-button" (click)="toggleMetadata()">▼</div>
        <div *ngIf="metadataExpanded" class="expand-button" (click)="toggleMetadata()">▲</div>
    </div>
    <div class="metadata-content">
        <div class="metadata-item">
            <div class="metadata-key">Identifier:</div>
            <div class="metadata-value">{{ propertyGroupName }}</div>
        </div>
        <div class="metadata-item">
            <div class="metadata-key">Catalogue item type:</div>
            <div class="metadata-value">Property group</div>
        </div>
        <div class="metadata-item">
            <div class="metadata-key"><b>Display name:</b></div>
            <div class="metadata-value"></div>
        </div>
        <div class="metadata-detailed-item">
            <div class="metadata-detail-key">English</div>
            <div class="metadata-detail-value">{{ propertyGroupName }}</div>
        </div>
        <div class="metadata-item">
            <div class="metadata-key"><b>Description:</b></div>
            <div class="metadata-value"></div>
        </div>
        <div class="metadata-detailed-item">
            <div class="metadata-detail-key">English</div>
            <div class="metadata-detail-value">description</div>
        </div>
        <div class="metadata-item">
            <div class="metadata-key">Last edited by:</div>
            <div class="metadata-value">john.doe</div>
        </div>
        <div class="metadata-item">
            <div class="metadata-key">Last edited on:</div>
            <div class="metadata-value">1 Feb 2025</div>
        </div>
    </div>
</div>

<div class="content-container">
    <div class="tree-container">
        <mat-tree #tree [dataSource]="treeData" [childrenAccessor]="childrenAccessor">
            <!-- Leaf node -->
            <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
                <button mat-icon-button disabled></button>
                <span [innerHTML]="node.name"></span>
            </mat-tree-node>

            <!-- Expandable node -->
            <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding matTreeNodeToggle>
                <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
                    <mat-icon>
                        {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                    </mat-icon>
                </button>
                <span [innerHTML]="node.name"></span>
            </mat-tree-node>
        </mat-tree>
    </div>
    <div class="feature-info-container">
        <div class="info-title">
            <div class="official-data">Official Data</div>
            <div class="smaller">(effective 1 FEB 2025)</div>
        </div>
        <div class="occuriencies">Occurencies: 26</div>
    </div>
</div>